import React, { useMemo } from 'react';

import { Grid, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { LoadingPage, RecordContextProvider, useRedirect } from 'react-admin';

import { useParams } from 'react-router-dom';

import useEntityData from '../../../../../../hooks/useEntityData';

import { SanctionListMatches } from '../../../../../../utilities/schemas/sanctionListMatches';

import actions from '../../../../../../constants/actions';
import SanctionMatchInformation from '../../../../../sanction/SanctionMatchInformation';
import SanctionAboutBusiness from '../../../../../sanction/SanctionAboutBusiness';
import SanctionImages from '../../../../../sanction/SanctionImages';
import SanctionSanctions from '../../../../../sanction/SanctionSanctions';
import SanctionRelatedEntities from '../../../../../sanction/SanctionRelatedEntities';
import SanctionSources from '../../../../../sanction/SanctionSources';

const GoBackButton = () => {
  const redirect = useRedirect();

  return (
    <IconButton onClick={() => { redirect('..'); }} size="small">
      <ArrowBackIosIcon color="inherit" fontSize="medium" />
    </IconButton>
  );
};

const BusinessSanctionDetails = () => {
  const {
    data,
    isLoading,
  } = useEntityData<SanctionListMatches>({
    source: 'sanction-list',
    getAction: actions.BUSINESS_GET_SANCTION_LIST_COMPANY,
  });

  const { sanctionId } = useParams();

  const currentSanction = useMemo(
    () => data?.potentialMatches.find((match) => match._id === sanctionId),
    [data, sanctionId],
  );

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <RecordContextProvider value={{ ...currentSanction, providerName: data?.providerName }}>
      <Grid container spacing={4}>
        <Grid size={12}>
          <GoBackButton />
        </Grid>
        <Grid size={12}>
          <Grid container spacing={6}>
            <Grid size={12}>
              <SanctionMatchInformation />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <SanctionAboutBusiness />
                </Grid>
                <Grid size={12}>
                  <SanctionImages isBusiness />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <SanctionSanctions />
                </Grid>
                <Grid size={12}>
                  <SanctionRelatedEntities />
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <SanctionSources />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </RecordContextProvider>
  );
};

export default BusinessSanctionDetails;
